import { defineMessages } from "@/i18n";
import en from "./en";

export const panelsSearchMessages = defineMessages("panels-search", en);
